module.exports = __webpack_public_path__ + "static/media/3-kanskje.b86c722e.mp3";